export function checkRouteInclude(pathname: string, paths: string[] = []) {
  let routeMatched = false;
  paths.forEach((eachPath) => {
    if (pathname.includes(eachPath)) {
      routeMatched = true;
    }
  });
  return routeMatched;
}

export const isLoginPage = (pathname: string) => checkRouteInclude(pathname, ["/login"]);

export const isShoppingCartPage = (pathname: string) => checkRouteInclude(pathname, ["/shopping-cart"]);
export const isCheckoutOrShoppingCartPage = (pathname: string) => checkRouteInclude(pathname, ["/shopping-cart", "/checkout"]);

export const isCheckoutS4Page = (pathname: string, query) => checkRouteInclude(pathname, ["/checkout/[sx]"]) && query.sx === "s4";
export const isCheckoutS3Page = (pathname: string, query) => checkRouteInclude(pathname, ["/checkout/[sx]"]) && query.sx === "s3";
export const isCheckoutFlowPages = (pathname: string, query) => checkRouteInclude(pathname, ["/checkout/[sx]"])
&& ["s2", "s3", "s4"].includes(query.sx);

export const isCheckoutPages = (pathname: string, query) => ((checkRouteInclude(pathname, ["/checkout/[sx]"])
&& (query.sx === "s1" || query.sx === "s2" || query.sx === "s3" || query.sx === "s4"))
|| (checkRouteInclude(pathname, ["/checkout/[sx]/[orderId]"]) && query.sx === "s5"));
